import {Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {Centre} from "../../../../interfaces/Centres";
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import {ChildService} from "../../../../components/child/child.service";
import {environment} from "../../../../../environments/environment";
import firebase from "firebase/compat";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import * as XLSX from 'xlsx';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatSelectChange} from "@angular/material/select";
import {EmployeeService} from "../../../../services/employee.service";

@Component({
    selector: 'app-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
    selectedCentre:string| null = "All";
    selectedChildCode?: any;
    centres$: Observable<Centre[]>;
    childrenData: FullChild[] = []

    childBycentre: Observable<FullChild[]> | undefined;
    dataSource: any;
    displayedColumns: string[] = ['childName', 'centreName', 'sessionType', 'date', 'challenges', 'intervention','submittedBy'];
    baseRef: AngularFirestoreCollection<any>
    env = environment.productionMode
    challenges: any;
    intervention: any;
    startDate: Date | undefined | null;
    endDate: Date | undefined | null;
    selectedIntervention: any;
    selectedChallenges: any;
    @ViewChild(MatTable) table!: MatTable<any>;
    fileName = 'Progress_Report.xlsx';
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    counsellors$:Observable<any>
    data:any[]=[]
    selectedCounsellor:string|null=null
    constructor(private mCentreService: CentreService,
                private mFirestore: AngularFirestore,
                private  readonly  mEmployeeService:EmployeeService,
                private childService: ChildService) {
        this.centres$ = this.mCentreService.getAllCentres().pipe(
          map(centres => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())))
        );
        this.counsellors$ = this.mEmployeeService.getCounsellers()
        this.baseRef = this.mFirestore.collection<any>(`${this.env.counseling}/allSessions/sessions/`);

    }

    ngOnInit(): void {
        //
        // let childObject = {
        //
        //   'childCode': this.selectedChildCode.childCode,
        //   'childName': this.selectedChildCode.firstName + ' ' + this.selectedChildCode.lastName,
        //   'parentsName': this.selectedChildCode.guardians[0]?.firstName + 'and ' + this.selectedChildCode.guardians[1]?.firstName,
        //
        // }
        // let myQuery: firebase.firestore.Query<any> = this.baseRef.ref;
        // if (this.selectedCentre!='All') {
        //   console.log('into selected Centre')
        //   myQuery = myQuery.where('centreCode', '==', this.selectedCentre);
        //
        // }
        // if (this.selectedChildCode!=null) {
        //   console.log('into selected Centre')
        //   myQuery = myQuery.where('childCode', '==', this.selectedChildCode.childCode);
        //
        // }
        // myQuery.get().then(res=>
        // {
        //   let data = res.docs.map(x=>x.data())
        //   this.dataSource = new MatTableDataSource(data)})
    }

    search() {
        if (this.selectedCentre != null) {
            this.childBycentre = this.childService.getAllotedChildListByCenter(this.selectedCentre!)
        }

    }


    fetchChildren($event: MatSelectChange) {
        let centreCode = $event.value
        // alert(centre)
        this.childrenData = []
        this.childService.fetchAllotedChildListByCenter(centreCode).subscribe(res => {
            res.forEach(it =>
                this.childrenData.push(it.data() as FullChild))

        })
        this.orderChildrenData()
        this.childService.getDischargeChildsBeforeThreeDaysFromCurrentDateByCentre(centreCode).then(res => {
            let c = res.docs.map(x => x.data() as FullChild)
            console.log('DISCHARGED CHILDREN IN SELECT', c.length)
            c.forEach(res => {
                this.childrenData.push(res)

            })
            this.orderChildrenData()

        })
        this.orderChildrenData()

    }

    getDate(date: string | undefined) {

    }

    applyFilter($event: KeyboardEvent) {
        const filterValue = ($event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

    }

    getData() {
        // let childObject = {
        //     'childCode': this.selectedChildCode.childCode,
        //     'childName': this.selectedChildCode.firstName + ' ' + this.selectedChildCode.lastName,
        //     'parentsName': this.selectedChildCode.guardians[0]?.firstName + 'and ' + this.selectedChildCode.guardians[1]?.firstName,
        //
        // }
        let myQuery: firebase.firestore.Query<any> = this.baseRef.ref;
        myQuery = myQuery.orderBy('date', 'desc')

        if (this.selectedCentre != 'All') {
            console.log('into selected Centre')
            myQuery = myQuery.where('centreCode', '==', this.selectedCentre);

        }
        if (this.selectedChildCode != null) {
            console.log('into selected Centre')
            myQuery = myQuery.where('childCode', '==', this.selectedChildCode.childCode);

        }
        myQuery.get().then(res => {
            this.data = res.docs.map(x => x.data())

            console.log("query data:", this.data)
           this.data.forEach(it => {
                if (it.challengesFaced != null) (it.challengesFaced as Array<string>)
                    .forEach(it => {
                  try {
                      this.challenges.push(it)
                  }catch (e){
                      console.log(e)
                  }

                    })
            })
            console.log('Challenges Faced', this.challenges)
            const frequencyMap = new Map<string, number>();

            if (this.challenges != null) this.challenges.forEach((challenge: string) => {
                frequencyMap.set(challenge, (frequencyMap.get(challenge) || 0) + 1)
            });
            let label: string[] = []
            let labelcount: number[] = []

            frequencyMap.forEach((value, key, map) => {
                label.push(key) //key e.g. Generic
                labelcount.push(value) // Generic Count e.g. 33
            })
            console.log('LABELS:', label);
            console.log('LABEL COUNT:', labelcount);


            // this.data.forEach(it => {
            //     console.log("here", it.interventions)
            //
            //     if (it.interventions) (it.interventions as Array<string>).forEach(it1 => {
            // if(it1 && it)            this.intervention.push(it1)
            //         })
            // })
            // console.log("count", labelcount)
            //
            // console.log('Intervention ', this.intervention)
            // console.log('challenges ', this.challenges)
            this.filterCounsellor()
            this.dataSource = new MatTableDataSource(this.data)
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });


    }

    exportexcel() {
        /* assessment-table id is passed over here */
        let element = document.getElementById('excel-table');

        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
        // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
        // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
        ws['!cols'] = [];
        ws['!cols'][19] = {hidden: true};

        /* O1 is your Column in Excel*/

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);


    }

    orderChildrenData() {
        this.childrenData.sort((a, b) => {
            const firstNameA = a.firstName.toLowerCase();
            const firstNameB = b.firstName.toLowerCase();
            if (firstNameA < firstNameB) {
                return -1;
            }
            if (firstNameA > firstNameB) {
                return 1;
            }
            return 0;
        });
    }
filterCounsellor(){
        if(this.selectedCounsellor){
            // alert(this.selectedCounsellor)
            this.data = this.data.filter(x=>x.submittedBy==this.selectedCounsellor)
    }
}

  Clear() {
    this.selectedCentre = null
    this.selectedChildCode = null
    this.startDate =null
    this.endDate =null
  }
}
